<script setup lang="ts">
import { APP_NAME, getPageTitle } from "@/assets/js/appConfig";
import { useDefaultStore } from "@/store";

;

const store = useDefaultStore();

useHead({
	title: getPageTitle("Music - Leaderboard"),
	meta: [
		{
			name: "title",
			content: getPageTitle("Music - Leaderboard"),
		},
		{
			name: "description",
			content:
				`See the top scores in Music Leaderboard and compare your results with other ${APP_NAME} players.`,
		},
		{ name: "robots", content: "index, follow" },
		{
			property: "og:title",
			content: getPageTitle("Music - Leaderboard"),
		},
		{
			property: "og:description",
			content:
				`See the top scores in Music Leaderboard and compare your results with other ${APP_NAME} players.`,
		},
		{ property: "og:site_name", content: APP_NAME },
		{
			name: "viewport",
			content: "width=device-width, initial-scale=1, viewport-fit=cover",
		},
	],
});
</script>

<template>
	<LeaderboardComp
		route-name="MusicPage"
		category-name="Music"
		:category-code="store.MAIN_CATEGORIES.MUSIC"
	/>
</template>
